import { IPublicClientApplication } from '@azure/msal-browser';
import { CountryScope } from '../../models';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import { getCountries } from './index';

export const createCountriesApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getCountries: (instance: IPublicClientApplication, scope: CountryScope, searchText?: string) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getCountries(fetchContext, scope, searchText, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getCountries', isInFlight);
    },
  ),
});
